import { createSlice } from '@reduxjs/toolkit'
import { UI_CONSTANTS } from '../../utils/constants/UIConstants'

export interface AtlasSandState {
  user: Record<string, any>
  idToken: string
  authorizedUser: Record<string, any>
  accessToken: string
  permissionList: any
  widgetIdMapping: any
  isFireFighterAccessEnabled: boolean | null
  isFirefighterLoading: boolean
  refreshToken: string
  appConfig: undefined | { legalTermsUrl?: string }
}
interface WidgetMappingAttribute {
  widgetName: string
  widgetCapabilityCode: string
}
const formatWidgetMapping = (data: WidgetMappingAttribute[]) => {
  if (data?.length > 0) {
    const formattedData: Record<string, string> = {}
    data.forEach((item: WidgetMappingAttribute) => {
      if (item?.widgetName) {
        formattedData[item.widgetName] = item.widgetCapabilityCode
      }
    })
    return formattedData
  }
  return {}
}
const initialState: AtlasSandState = {
  user: {},
  idToken: '',
  authorizedUser: {},
  accessToken: '',
  permissionList: undefined,
  widgetIdMapping: undefined,
  isFireFighterAccessEnabled: null,
  isFirefighterLoading: false,
  refreshToken: '',
  appConfig: undefined,
}

const atlasSandSlice = createSlice({
  name: 'atlasSand',
  initialState,
  reducers: {
    setAtlasData(state, action) {
      const { method, data } = action.payload
      switch (method) {
        case UI_CONSTANTS.USER:
          return {
            ...state,
            user: data.user,
            idToken: data.idToken,
          }

        case UI_CONSTANTS.AUTHORIZED_USER:
          return {
            ...state,
            authorizedUser: data,
            accessToken: data.accessToken,
            permissionList: data?.widgetCapabilitiy?.capabilities,
            widgetIdMapping: formatWidgetMapping(
              data?.widgetCapabilitiy?.widgetCapabilities,
            ),
          }
        default:
          return state
      }
    },
    setIsFireFighterAccessEnabled(state, action: { payload: boolean | null }) {
      state.isFireFighterAccessEnabled = action.payload
    },
    setRefreshToken(state, action: { payload: string }) {
      state.refreshToken = action.payload
    },
    setAccessToken(state, action: { payload: string }) {
      state.accessToken = action.payload
    },
    setIsFirefighterLoading(state, action: { payload: boolean }) {
      state.isFirefighterLoading = action.payload
    },
    setAppConfig(state, action: { payload: undefined | object }) {
      state.appConfig = action.payload
    },
  },
})

export const {
  setAtlasData,
  setIsFireFighterAccessEnabled,
  setRefreshToken,
  setAccessToken,
  setIsFirefighterLoading,
  setAppConfig,
} = atlasSandSlice.actions
export default atlasSandSlice.reducer
